import { render, staticRenderFns } from "./AlarmHistory.vue?vue&type=template&id=5f97991a&scoped=true"
import script from "./AlarmHistory.vue?vue&type=script&lang=js"
export * from "./AlarmHistory.vue?vue&type=script&lang=js"
import style0 from "./AlarmHistory.vue?vue&type=style&index=0&id=5f97991a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f97991a",
  null
  
)

export default component.exports